"use client";

import React, { ReactNode } from "react";

import { ProductTileClickContext } from "@faire/retailer/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/ProductTileClickProvider/ProductTileClickContext";
import { ILeanProductTile } from "@faire/retailer/features/MarketplaceItems/MarketplaceProduct/LeanProtos/ILeanProductTile";

import { useOnProductClickBase } from "../../../productTileActions/useOnProductClickBase";

export const SDUIEvaluateProductTileClickProvider = ({
  productUrl,
  productTile,
  children,
}: {
  productUrl: string;
  productTile: ILeanProductTile;
  children: ReactNode;
}) => {
  const onProductClick = useOnProductClickBase({
    token: productTile.product?.token,
    bestImage: productTile.best_image,
    images: productTile.images,
    impressionId: productTile.product?.impression_id ?? "",
    promotedBy: productTile.product?.promoted_by ?? [],
  });
  return (
    <ProductTileClickContext.Provider
      value={{
        productLinkProps: { productUrl },
        onProductClick,
      }}
    >
      {children}
    </ProductTileClickContext.Provider>
  );
};
